import PropTypes from 'prop-types';
import { useState } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
// @mui
import { Box, Collapse, List, ListItemText, ListSubheader } from '@mui/material';
//
import { StyledNavItem, StyledNavItemIcon } from './styles';
import { GloginComponent } from '../glogin';
import Iconify from '../iconify';

// ----------------------------------------------------------------------

NavSection.propTypes = {
  data: PropTypes.array,
};

export default function NavSection({ data = [], ...other }) {
  // Group items by subheader sections
  const sections = [];
  let current = { subheader: null, items: [] };
  for (const item of data) {
    if (item.subheader) {
      if (current.items.length > 0 || current.subheader) sections.push(current);
      current = { subheader: item.subheader, items: [] };
    } else {
      current.items.push(item);
    }
  }
  if (current.items.length > 0 || current.subheader) sections.push(current);

  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 1 }}>
        {sections.map((section, si) =>
          section.subheader
            ? <CollapsibleSection key={section.subheader} section={section} />
            : section.items.map(item => <NavItem key={item.title} item={item} />)
        )}
      </List>
    </Box>
  );
}

// ----------------------------------------------------------------------

function CollapsibleSection({ section }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <ListSubheader
        disableSticky
        onClick={() => setOpen(v => !v)}
        sx={{
          px: 2.5, pt: 1.5, pb: 0.5, fontSize: 11, fontWeight: 700,
          lineHeight: '24px', color: 'text.disabled', textTransform: 'uppercase',
          bgcolor: 'transparent', cursor: 'pointer', display: 'flex', alignItems: 'center',
          userSelect: 'none',
        }}
      >
        {section.subheader}
        <Iconify
          icon={open ? 'eva:chevron-down-fill' : 'eva:chevron-right-fill'}
          sx={{ width: 14, height: 14, ml: 'auto', color: 'text.disabled' }}
        />
      </ListSubheader>
      <Collapse in={open}>
        {section.items.map(item => <NavItem key={item.title} item={item} />)}
      </Collapse>
    </>
  );
}

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item }) {
  const { title, path, icon, info } = item;

  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      sx={{
        '&.active': {
          color: 'text.primary',
          bgcolor: 'action.selected',
          fontWeight: 'fontWeightBold',
        },
      }}
    >
      <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>

      <ListItemText disableTypography primary={title} />

      {info && info}
    </StyledNavItem>
  );
}
